import { render } from "./EventsTab.vue?vue&type=template&id=071ed717"
import script from "./EventsTab.vue?vue&type=script&lang=js"
export * from "./EventsTab.vue?vue&type=script&lang=js"

import exportComponent from "/mnt/build/cloudstack/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__